import { IdentificationContainer } from '../identification';
import { PersonalInformationFields } from '../personal-information';
import { Flex } from '@servicetitan/anvil2';
import { ApplicationData, ApplicationDataStore } from '../application/ApplicationDataStore';
import { createSchema } from './schema';
import { SaveFormDataToStore } from '../application/SaveFormDataToStore';
import { Form, FormProps } from '../common/Form';
import { useMemo } from 'react';
import { deleteUndefinedKeys } from '@servicetitan/financing-utils-shared';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { JobDetailsFields } from '../job-details/JobDetailsFields';

export const Container = (
    props: Omit<
        FormProps<ApplicationData['applicant']>,
        'schema' | 'defaultValues' | 'formData' | 'children'
    >,
) => {
    const { applicationData } = ApplicationDataStore.useStore();
    const config = useProviderConfig();
    // Keep backward compatibility check for identification and jobDetails section visibility
    const { additionalApplicantFields = [] } = config;
    const requiresIdentification = additionalApplicantFields.includes('identification');
    const requiresJobDetails = additionalApplicantFields.includes('jobDetails');

    // Get only the default values from the application data and cache the result
    // so we aren't sending all the application data to the form on every change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const applicantData = useMemo(() => deleteUndefinedKeys(applicationData.applicant), []);

    const schema = useMemo(() => {
        return createSchema(config);
    }, [config]);

    return (
        <Form {...props} formData={applicantData} schema={schema}>
            <SaveFormDataToStore fieldPrefix="applicant" />
            <Flex direction="column" gap="10">
                <PersonalInformationFields fieldPrefix="primaryApplicant" />
                {requiresIdentification && (
                    <IdentificationContainer fieldPrefix="primaryApplicant" />
                )}
                {requiresJobDetails && <JobDetailsFields fieldPrefix="primaryApplicant" />}
            </Flex>
        </Form>
    );
};
